import {createAction} from '@reduxjs/toolkit'
import {IdZreportsStateDataItem , typeZreportsFilters} from './dZreportReducer'
import {typePagination, typeRequestPagination} from '../system/constants';
import { LANGUAGE } from 'locales/languages';




// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data
export const dZReportsSetDataAC = createAction(
    'D_ZREPORTS_SET_DATA',
    (dataList: IdZreportsStateDataItem[]) => ({payload: {dataList}})
)



// Action creator of saga set data
export const dZReportsSetDataSagaAC = createAction(
    'D_ZREPORTS_SET_DATA_SAGA',
    (
        filters: typeZreportsFilters,
        paginationRequest: typeRequestPagination
    ) => ({payload: {filters, paginationRequest}})

)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set item data
export const dZReportsSetDetailItemAC = createAction(
    'D_ZREPORTS_SET_DETAIL_ITEM',
    (detailItemId: string) => ({payload: detailItemId})
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of clear filtersForm
export const dZReportsClearFiltersAC = createAction(
    'D_ZREPORTS_CLEAR_FILTERS',
)

// Action creator of set filtersForm
export const dZReportsSetFiltersAC = createAction(
    'D_ZREPORTS_SET_FILTERS',
    (filtersObject: typeZreportsFilters) => ({payload: filtersObject})
)

// Action creator of set filtersForm saga
export const dZReportsSetFiltersSagaAC = createAction(
    'D_ZREPORTS_SET_FILTERS_SAGA',
    (filtersObject: typeZreportsFilters, paginationRequest: typeRequestPagination) => ({payload: {filtersObject, paginationRequest}})
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set checked item
export const dZReportsCheckedItemAC = createAction(
    'D_ZREPORTS_CHECK_ITEM',
    (itemId: string) => ({payload: itemId})
)

// Action creator of checked all items
export const dZReportsCheckedAllItemAC = createAction(
    'D_ZREPORTS_CHECK_ALL_ITEM',
    (value: boolean) => ({payload: value})
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of export data
export const dZReportsExportDataSagaAC = createAction(
    'D_ZREPORTS_EXPORT_DATA_SAGA',
    (zReportsIds: string[]) => ({payload: {zReportsIds}})
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set pagination
export const dZReportsSetPaginationAC = createAction(
    'D_ZREPORTS_SET_PAGINATION',
    (
        pagination: typePagination,
    ) => ({payload: {pagination}})
)

// Action creator of set itemsForPage in pagination
export const dZReportsSetItemsForPageAC = createAction(
    'D_ZREPORTS_SET_ITEMS_FOR_PAGE',
    (
        itemsForPage: number,
    ) => ( { payload: { itemsForPage } } )
)


// Action creator of set pageNumber in pagination
export const dZReportsSetPageNumberAC = createAction(
    'D_ZREPORTS_SET_PAGE_NUMBER',
    (
        pageNumber: number,
    ) => ({payload: {pageNumber}})
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of export sale from z report
export const dZReportsExportSalesSagaAC = createAction(
    'D_ZREPORTS_EXPORT_SALES_SAGA',
    (zReportsIds: string[], lang: LANGUAGE) => ({payload: {zReportsIds, lang}})
)
